import { inject, Pipe, PipeTransform } from '@angular/core';
import { getTimePeriod, Invoice } from '@marmon/shared/types/analysis';
import { AnalysisStateService } from '../services';
import { TranslocoService } from '@jsverse/transloco';

@Pipe({
	standalone: true,
	name: 'invoiceTimePeriod',
})
export class InvoiceTimePeriodPipe implements PipeTransform {
	private readonly analysisStateService = inject(AnalysisStateService);
	private readonly transloco = inject(TranslocoService);

	transform(invoice: Invoice) {
		const analysis = this.analysisStateService.analysis;
		if (!analysis) return '';

		// +1 to make it human-readable. Time Period 0 would not make sense to the user
		const { period } = getTimePeriod(invoice, analysis.timePeriods);

		// if the period is less than 0 than it wasn't determined
		if (period < 0) return '';
		return this.transloco.translate(`analysis.time-period.${period + 1}`);
	}
}
